import React from "react";

import { DocumentTypeSelector } from "./DocumentTypeSelector";
import { CameraAccess } from "./CameraAccess";
import { useIncode } from "./IncodeContext";
import { ProcessId } from "./ProcessId";
import { Retry } from "./Retry";
import { Step } from "./Step";
import { TutorialBackId } from "./TutorialBackId";
import { TutorialFrontId } from "./TutorialFrontId";
import { TutorialPassport } from "./TutorialPassport";
import { TutorialSelfie } from "./TutorialSelfie";

export const Router = () => {
  const { step } = useIncode();

  switch (step) {
    case "document_type":
      return <DocumentTypeSelector />;
    case "tutorial_passport":
      return <TutorialPassport />;
    case "passport":
      return <Step name="passport" next="process_id" />;
    case "enable_camera_access":
      return <CameraAccess />;
    case "tutorial_front":
      return <TutorialFrontId />;
    case "front":
      return <Step name="front" next="tutorial_back" />;
    case "tutorial_back":
      return <TutorialBackId />;
    case "back":
      return <Step name="back" next="process_id" />;
    case "process_id":
      return <ProcessId />;
    case "tutorial_selfie":
      return <TutorialSelfie />;
    case "selfie":
      return <Step name="selfie" next="retry" />;
    case "retry":
      return <Retry numberOfTries={3} next="" />;
    default:
      return null;
  }
};
